import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
        <div className="flex flex-col md:flex-row gap-8 md:gap-16">
          <div className="md:w-1/3">
            <h3 className="text-lg font-heading font-bold text-background-50 mb-3">
              韩漫网
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              {t('home.footerBrand')}。致力于为漫画爱好者提供最新、最全、最优质的韩漫资源。
            </p>
          </div>

          <div className="flex-1 flex flex-wrap gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-3">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('common.home')}</Link>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('common.category')}</Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">{t('common.about')}</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-3">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors">恋爱甜宠</Link>
                <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors">奇幻冒险</Link>
                <Link to="/category/action" className="text-sm text-background-400 hover:text-background-100 transition-colors">热血动作</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-3">联系我们</h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-background-400">contact@hanmanwang.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {t('home.footerBrand')}。本站所有漫画内容仅供学习交流使用。
          </p>
        </div>
      </div>
    </footer>
  );
}